export default __webpack_public_path__ + "static/bariol_serif_regular-webfont-6214d53bb64c9e3a678d090173004606.eot";